"use client";

// Полоса ожидания вверху экрана. Состояние — в lib/top-progress.ts (считает
// запросы в полёте), здесь только отрисовка. Монтируется один раз в app-shell.

import { useEffect, useState } from "react";
import { subscribeTopProgress } from "@/lib/top-progress";
import { Z } from "@/lib/z";

export function TopProgress() {
  const [visible, setVisible] = useState(false);
  useEffect(() => subscribeTopProgress(setVisible), []);

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-x-0 top-0"
      style={{ zIndex: Z.TOP_PROGRESS, height: 2 }}
    >
      {/* Полоса не исчезает мгновенно: доезжает и гаснет за 260 мс, иначе на
          быстром ответе выглядит как сбой отрисовки. */}
      <div
        className={`wait-bar is-indeterminate ${visible ? "" : "opacity-0"}`}
        style={{ height: 2, borderRadius: 0, background: "transparent", transition: "opacity 260ms ease-out" }}
      >
        <i style={{ height: 2 }} />
      </div>
    </div>
  );
}
